import moment from 'moment'
import Select from 'react-select'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Link, Route, Switch } from 'react-router-dom'
import { Badge, DatePicker, Menu, Dropdown } from 'antd'

import { AiOutlineDown, AiOutlineReload } from 'react-icons/ai'

import { presets, stringifyDate, useListData, usePet, useToggle } from '../modules'

import Receive from '../components/reusable/receive'
import Patient from '../components/reusable/patient'

import PatientDetails from '../components/drawers/patient'
import Vitals from '../components/drawers/vitals'
import Requests from '../components/drawers/requests'
import { FaHandHolding } from 'react-icons/fa'
import CallForPatient from '../components/reusable/callForPatient'
import Confirm from '../components/reusable/confirm'

const { RangePicker } = DatePicker

const Triage = () => {
    const [ranges, setRanges] = useState([moment().startOf('day'), moment().endOf('day')])
    const [chosen, setChosen] = useState([])
    const [type, setType] = useState({ label: 'All', value: 'All' })
    const [string, setString] = useState('')
    const [sIString, setSIString] = useState('')
    const [cId, setCId] = useState()
    
    const [select, toggleSelect] = useToggle()
    const [notSeen, toggleNSeen] = useToggle(true)

    // usePet('pendingAppointments', null, { notify: false, callback: ({ data }) => setPCount(data) })

    // usePet('pendingForwards', null, { notify: false, callback: ({ data }) => setFCount(data) })

    const [
        { loading: qLoading, error: qError, fetch: fetchQueue },
        { list: queue },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('triageQueue', ranges ? { 
        string, 
        pendingOnly: notSeen,
        from: ranges[0]?._d ?? null, 
        to: ranges[1]?._d ?? null,
        type: type?.value,
        order: notSeen ? 1 : -1
    } : { string, pendingOnly: notSeen, type: type?.value, order: notSeen ? 1 : -1 }, { notify: true }, 'entries')

    const [
        { loading: sILoading, error: sIError, fetch: fetchSaleItems },
        { list: saleItems = [] }
    ] = useListData('pointOfSaleItems', { category: 'Doctor', string: sIString }, { notify: true }, 'items')

    const { user } = useSelector(state => state.application)

    const choose = id => {
        let temp = [...chosen]

        if (temp.includes(id)) {
            temp = temp.filter(x => x !== id)
        } else {
            temp.push(id)
        }

        setChosen(temp)
    }

    const refresh = () => {
        navigate(1)
        fetchQueue()
    }

    let callback = (_, notify, ops) => {
        refresh()
        notify('Changes have been saved', ops('success'))
    }

    const [, toggleSeen] = usePet('toggleSeenStatus', { 
        id: cId
    }, { notify: true, callback, manual: true, load: { msg: 'Changing status...' } }) 

    const [, toggleDiscard] = usePet('toggleDiscardStatus', { 
        id: cId
    }, { notify: true, callback, manual: true, load: { msg: 'Changing status...' } })

    const filterByType = typ => {
        setType(typ)
        refresh()
    }

    const search = str => {
        setString(str)
        refresh()
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    }

    const toggleNotSeen = () => {
        toggleNSeen()
        refresh()
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            {/* Modals */}
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-search"
                    type="text"
                    placeholder="Patient Name, OP/IP No." />
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    <RangePicker value={ ranges } onChange={selectRange} ranges={ presets } />
                    <Dropdown
                        overlay={
                            <Menu>
                                <Menu.Item onClick={() => null}>Patient Visits</Menu.Item>
                            </Menu>
                        }>
                        <button className="btn hisani-btn-green-light ml-2 text-white">
                            <span className="hidden xs:block mr-2">Reports</span>
                            <AiOutlineDown />
                        </button>
                    </Dropdown>
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <span>
                        <h2 className="font-semibold text-gray-800 mb-1">Triage' Queue</h2>
                        <span>
                            <input
                                onChange={ toggleNotSeen }
                                checked={ notSeen }
                                type="checkbox"
                                className="form-checkbox cursor-pointer h-5 w-5" />
                            <span className="text-gray-500 text-xs italic ml-2">Only Show Pending</span>
                        </span>
                    </span>
                    <span className="flex items-center justify-between">
                        <Receive
                            loading={sILoading}
                            error={sIError}>
                            <Select
                                value={type}
                                onChange={filterByType}
                                styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                options={ [{ label: 'All', value: 'All' }, ...saleItems.map(item => ({ label: item.name, value: item._id }))] }
                                placeholder="Filter By Type" />
                        </Receive>
                        <button onClick={refresh} className="btn ml-2 py-3 hisani-btn-green-light text-white">
                            <AiOutlineReload style={{ color: "white" }} />
                        </button>
                        <Link className="ml-2" to={ `/app/triage/requests` }>
                            <button className="btn hisani-btn-green-light text-white flex items-center justify-between">
                                <FaHandHolding />
                                <span className="xs:block ml-2">Requests</span>
                            </button>
                        </Link>
                    </span>
                </header>
                <div className="p-3">
                    <Receive
                        progress
                        loading={qLoading}
                        error={qError}>
                        {
                            queue?.length > 0 ?
                                <div className="overflow-x-auto">
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">{select ? 'Selected' : 'No'}</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Patient Name</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Paid For</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Date of Visit</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                queue.map((entry, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">
                                                                {
                                                                    select ?
                                                                        <input
                                                                            onChange={() => choose(entry._id)}
                                                                            checked={chosen.includes(entry._id)}
                                                                            type="checkbox"
                                                                            className="form-checkbox cursor-pointer h-5 w-5" />
                                                                        :
                                                                        `${((page - 1) * limit) + (key + 1)}.`
                                                                }
                                                            </div>
                                                        </td>
                                                        <td className="p-2">
                                                            <Patient patient={ entry?.ref?.patient } />
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-left">{ entry?.ref?.name ?? entry?.item?.name }</div>
                                                            <div className="flex space-x-2 pl-1 items-center">
                                                                <div className={ `w-2 h-2 rounded-full bg-${ entry.filled ? 'green' : entry.discarded ? 'gray' : 'yellow'}-500 shadow` }></div>
                                                                <p className={ `text-${ entry.filled ? 'green': entry.discarded ? 'gray' : 'yellow'}-500 block text-xs italic mb-0` }>{ entry.filled ? `Seen by ${entry?.filledBy?.name}`: entry.discarded ? 'Discarded' : 'Pending' }</p>
                                                            </div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{stringifyDate(entry.date)}</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Dropdown
                                                                overlay={
                                                                    <Menu>
                                                                        <Link to={ `/app/triage/${entry._id}` }><Menu.Item>{ entry.filled ? 'Review' : 'Take' } Vitals</Menu.Item></Link>
                                                                        <Link to={ `/app/triage/patients/${entry?.ref?.patient?._id}` }><Menu.Item>Patient Details</Menu.Item></Link>
                                                                        <Menu.Item onClick={ () => null }>Refer Patient</Menu.Item>
                                                                        <CallForPatient item={ entry?.ref?._id } patient={ entry?.ref?.patient } />
                                                                        <Menu.Item onClick={ () => {
                                                                            setCId(entry?._id)
                                                                            Confirm({
                                                                                title: entry?.discarded ? 'Restore This Record' : 'Discard This Record',
                                                                                message: entry?.discarded ? 'This will undo the discard action applied to this record' : 'This will discard this record from the pending queue',
                                                                                okText: entry?.discarded ? 'Restore Record' : 'Discard Record',
                                                                                onOk: toggleDiscard
                                                                            }) 
                                                                        } }>{ entry?.discarded ? 'Restore Record' : 'Discard Record' }</Menu.Item>
                                                                        { 
                                                                            (user?.issuperuser || !entry?.filled) &&
                                                                            <Menu.Item onClick={ () => {
                                                                                setCId(entry?._id)
                                                                                Confirm({
                                                                                    title: entry?.filled ? 'Mark as Incomplete' : 'Mark as Completed',
                                                                                    message: `This will mark this record as ${ entry?.filled ? 'incomplete' : 'complete' }`,
                                                                                    okText: entry?.filled ? 'Mark Incomplete' : 'Mark Completed',
                                                                                    onOk: toggleSeen
                                                                                })
                                                                            } }>{ entry?.filled ? 'Mark Incomplete' : 'Mark Completed' }</Menu.Item>
                                                                        }
                                                                    </Menu>
                                                                }>
                                                                <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                :
                                <div className="w-full h-16 flex items-center justify-center">
                                    <p className="font-semibold text-base">No patients { string.trim().length > 2 ? `matching "${string}"` : "" } were found</p>
                                </div>
                        }
                    </Receive>
                    {Paginate}
                </div>
            </div>
            <Switch>
                <Route path="/app/triage/patients/:id">
                    <PatientDetails reload={ refresh } source="/app/triage" />
                </Route>
                <Route path="/app/triage/requests">
                    <Requests department="Triage" path="/app/triage" />
                </Route>
                <Route path="/app/triage/:id">
                    <Vitals onClose={ refresh } />
                </Route>
            </Switch>
        </div>       
    )
}

export default Triage